/**
 * @author Rohman Widiyanto
 * @email rohmansca@gmail.com
 * @create date 2022-02-07 22:34:56
 * @modify date 2022-02-07 22:34:56
 */
import React from 'react'
import { useTranslation } from 'react-i18next'
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Slide,
  Typography,
  IconButton
} from '@mui/material'
import { TransitionProps } from '@mui/material/transitions'
import { Close as CloseIcon } from '@mui/icons-material'
import ReactHtmlParser from 'react-html-parser'

import { ModalConfirmProps } from './modal-confirm.props'

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export const ModalConfirm: React.FC<ModalConfirmProps> = (props: ModalConfirmProps) => {
  const { t } = useTranslation()

  const {
    open, title, description, icon, onClose, onConfirm,
    confirm = t('common.confirm'),
    cancel = t('common.cancel'),
    align = 'center', alignButton = 'center',
    onCloseIcon,
  } = props

  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      keepMounted
      onClose={onClose}
    >
      <DialogContent sx={{pt: 4, pb: 2}}>
        {onCloseIcon &&
          <IconButton
            aria-label="close"
            onClick={onCloseIcon}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
            }}
          >
            <CloseIcon />
          </IconButton>
        }

        {icon}
        <Typography variant='h5' align={align} sx={{mb: 0.5}}>{title}</Typography>
        <Typography align={align} variant='body2'>
          {ReactHtmlParser(description)}
        </Typography>
      </DialogContent>
      <DialogActions sx={{mb: 4, justifyContent: alignButton}}>
        <Button variant='contained' onClick={onConfirm}>{confirm}</Button>
        <Button variant='outlined' onClick={onClose}>{cancel}</Button>
      </DialogActions>
    </Dialog>
  )
}
